export default "__VITE_ASSET__DJxVRqDH__"